import { keyframes } from "@angular/animations";
import { ContentControlledEventActionEnum } from '../enums';
import {
  ContentControlledEditingDirectiveInstructions,
  ContentControlledEditingDirective,
  ContentControlledEditingDirectiveViewModel,
} from '../editing-directive';
import { ContentControlledKeyframe } from '../keyframe';
import ContentControlStudioOperation from './content-control-studio-operation';
import { ContentControlSubtitlesContainer } from '../subtitles';

export default class ContentControlStudioUpdateEventFromSegmentOperation extends ContentControlStudioOperation {
  constructor(
    public event: ContentControlledEditingDirective,
    public segment: ContentControlledEditingDirectiveViewModel,
    public title: string,
    public action: ContentControlledEventActionEnum,
    public isApproved: boolean,
    public isMitigated: boolean,
    public startsAtMs: number,
    public endsAtMs: number,
    public keyframes: Array<ContentControlledKeyframe>,
    public startFrame?: string,
    public endFrame?: string,
    public keyframe?: ContentControlledKeyframe,
    public instructions?: ContentControlledEditingDirectiveInstructions,
    public subtitles?: ContentControlSubtitlesContainer,
    public createdAt?: number,
    callback?,
  ) {
    super(
      () => {
        if (event && segment) {
          event.title = segment.title;
          event.action = segment.action;
          event.mediaType = segment.mediaType;
          event.isApproved = segment.isApproved;
          event.isMitigated = segment.isMitigated;
          event.startsAtMs = segment.startsAtMs;
          event.endsAtMs = segment.endsAtMs;
          event.instructions = segment.instructions
            ? segment.instructions
            : undefined;
          event.subtitles = segment.subtitles?.clone() || undefined;
          event.createdAt = segment.createdAt;
          const existingKeyframe = keyframe && event.hasKeyframe(keyframe);
          if (existingKeyframe) {
            existingKeyframe.ingest(keyframe);
            existingKeyframe.timeInMs = keyframe.timeInMs;
            event.sortKeyframes();
          } else if (keyframe) {
            event.keyframes.push(keyframe);
            event.sortKeyframes();
          }
        }
      },
      () => {
        if (event) {
          event.keyframes = keyframes;
          event.isMitigated = isMitigated;
          event.isApproved = isApproved;
          event.startFrame = startFrame;
          event.endFrame = endFrame;
          event.startsAtMs = startsAtMs;
          event.endsAtMs = endsAtMs;
          event.action = action;
          event.title = title;
          event.instructions = instructions;
          event.subtitles = subtitles;
          event.createdAt = createdAt;
        }
      },
      callback,
    );
  }
}
